import { extractAddressFromImage } from 'common/api/fetcher/profile/mutations'
import { useMutation } from 'react-query'

export const useExtractAddressFromImage = () =>
  useMutation<string, Error, number>({
    mutationFn: (imageId: number) => extractAddressFromImage(imageId),
  })
